import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import { LANDING_PATH, SIGN_IN_PATH, SIGN_UP_PATH, DOMAIN_PATH } from 'routes';
import logo from 'images/logo.svg';
import connect from 'react-redux/es/connect/connect';

import ReactPixel from 'react-facebook-pixel';

class HeaderUnLoggedIn extends Component {
  state = {
    isMobileMenuOpen: false,
  };

  toggle = () => {
    this.setState({ isMobileMenuOpen: !this.state.isMobileMenuOpen });
  };

  close = () => {
    this.setState({ isMobileMenuOpen: false });
  };

  handleHowItWorks = () => {
    this.trigViewContent();
  };

  handlePricing = () => {
    this.triggLead();
    this.trigViewContent();
  };

  triggLead = () => {
    ReactPixel.track('Lead');
  };

  trigViewContent = () => {
    ReactPixel.track('ViewContent');
  };

  render() {
    const { isMobileMenuOpen } = this.state;
    const { isLoggedIn } = this.props;

    return (
      <div className="header">
        <div className="wrapper">
          <div className="header__content">
            <Link to="/" className="logo">
              <img src={logo} alt="" />
            </Link>
            <button
              className={isMobileMenuOpen ? 'menu-btn opened' : 'menu-btn'}
              onClick={this.toggle}>
              <div className="center-line" />
            </button>
            <div className={isMobileMenuOpen ? 'topline opened' : 'topline'}>
              <ul className="navmenu">
                <li className="navmenu__itm">
                  <a
                    href="/#how_it_works_section"
                    className="navmenu__link"
                    onClick={this.handleHowItWorks}>
                    How it works
                  </a>
                </li>
                <li className="navmenu__itm">
                  <a
                    href="/#pricing_plans"
                    className="navmenu__link"
                    onClick={this.handlePricing}>
                    Pricing
                  </a>
                </li>
                <li className="navmenu__itm">
                  <Link to="/faq" className="navmenu__link">
                    FAQ
                  </Link>
                </li>
                <li className="navmenu__itm">
                  <Link to="/contact" className="navmenu__link">
                    Contact us
                  </Link>
                </li>
              </ul>
              <Route
                exact
                path={LANDING_PATH}
                render={() => (
                  <div className="topline__registration">
                    {isLoggedIn ? (
                      <Link to={DOMAIN_PATH} className="topline-link">
                        Dashboard
                      </Link>
                    ) : (
                      <div>
                        <a
                          href="#pricing_plans"
                          className="btn btn-blue"
                          onClick={this.handlePricing}>
                          Sign up
                        </a>
                        <Link to={SIGN_IN_PATH} className="topline-link">
                          Sign in
                        </Link>
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateProps(state) {
  return {
    isLoggedIn: state.auth.isUserLoggedIn,
  };
}

export default connect(
  mapStateProps,
  null,
)(HeaderUnLoggedIn);



// WEBPACK FOOTER //
// ./src/scenes/Header/HeaderUnLoggedIn.js